import { render, staticRenderFns } from "./KlaimHadiahSpektakulerUpload.vue?vue&type=template&id=0f014643&scoped=true&"
import script from "./KlaimHadiahSpektakulerUpload.vue?vue&type=script&lang=js&"
export * from "./KlaimHadiahSpektakulerUpload.vue?vue&type=script&lang=js&"
import style0 from "./KlaimHadiahSpektakulerUpload.vue?vue&type=style&index=0&id=0f014643&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f014643",
  null
  
)

export default component.exports